import http from "@/http/aisea/axios";
import { MULTIPART } from "@/config/";

const resource = "/picture";

export default {
  // プロフィール系
  addUserPicture(payload) {
    return MULTIPART.post(`${resource}/profile`, payload.formData);
  },

  deleteUserPicture(pictureId) {
    return http.post(`${resource}/profile/${pictureId}`);
  },

  // 船舶系
  addVesselPicture(payload) {
    return MULTIPART.post(`${resource}/vessel`, payload.formData);
  },

  deleteVesselPicture(pictureId) {
    return http.delete(`${resource}/vessel/${pictureId}`);
  },

  // 船舶書類系
  addVesselDocumentPicture(payload) {
    return http.post(`${resource}/vessel/document`, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  deleteVesselDocumentPicture(pictureId) {
    return http.post(`${resource}/vessel/document/${pictureId}`);
  },
  // プロット系
  addPlotPicture(payload) {
    return MULTIPART.post(`${resource}/plot`, payload.formData);
  },

  deletePlotPicture(pictureId) {
    return http.post(`${resource}/plot/${pictureId}`);
  },
  // ライセンス系
  fetchLicensePicture(pictureId) {
    return http.get(`${resource}/license/${pictureId}`);
  },

  addLicensePicture(payload) {
    return http.post(`${resource}/license`, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  deleteLicensePicture(pictureId) {
    return http.delete(`${resource}/license/${pictureId}`);
  },

  // 共通系
  download(pictureId) {
    return http.get(`${resource}/download/${pictureId}`, {
      responseType: "blob"
    });
  }
};
